import React from "react";
import { useTranslation } from "../../i18n";

function TerminalCard() {
  const { t } = useTranslation();

  return (
    <div className="terminal-card-wrapper">
      <div className="terminal-card">
        <div className="terminal-header">
          <div className="terminal-traffic-lights">
            <span className="traffic-light traffic-light-red" />
            <span className="traffic-light traffic-light-yellow" />
            <span className="traffic-light traffic-light-green" />
          </div>
          <span className="terminal-title">{t("terminal.path")}</span>
        </div>

        <pre className="terminal-code">
          <code>
            <div className="terminal-line">
              <span className="token-keyword">const</span>{" "}
              <span className="token-identifier">developer</span>{" "}
              <span className="token-brace">{"{"}</span>
            </div>
            <div className="terminal-indent">
              <div className="terminal-line">
                <span className="token-key">name</span>
                <span className="token-punct">: </span>
                <span className="token-string">"Yuvasree Padmanabhan"</span>
                <span className="token-punct">,</span>
              </div>
              <div className="terminal-line">
                <span className="token-key">role</span>
                <span className="token-punct">: </span>
                <span className="token-string">"{t("terminal.role")}"</span>
                <span className="token-punct">,</span>
              </div>
              <div className="terminal-line">
                <span className="token-key">location</span>
                <span className="token-punct">: </span>
                <span className="token-string">"{t("terminal.location")}"</span>
                <span className="token-punct">,</span>
              </div>
              <div className="terminal-line">
                <span className="token-key">openToWork</span>
                <span className="token-punct">: </span>
                <span className="token-bool">true</span>
                <span className="token-punct">,</span>
              </div>
            </div>
            <div className="terminal-line">
              <span className="token-brace">{"}"}</span>
              <span className="token-punct">;</span>
            </div>
            <div className="terminal-line terminal-line-cursor">
              <span className="token-command">$</span>{" "}
              <span className="token-identifier">{t("terminal.command")}</span>
              <span className="cursor-blink" aria-hidden="true" />
            </div>
          </code>
        </pre>
      </div>
    </div>
  );
}

export default TerminalCard;
